<template>
  <div class="qr-container d-flex flex-column align-center justify-center">
    <img :src="reverLogoGrayscale" alt="logo" />

    <h2 class="my-12 blue-grey--text text--darken-3 h2 text-center pre-line">
      {{ $t('rev.create.qr_code_pdf_title') }}
    </h2>

    <QRCode size="370" level="L" :value="url" />

    <h4 class="mt-10 blue-grey--text text--darken-3 text-center h4">
      {{ $t('rev.create.qr_code_pdf_description') }}
    </h4>
  </div>
</template>

<script>
import QRCode from 'qrcode.vue'

import config from '@/config'
import reverLogoGrayscale from '@/assets/images/logo-bw.svg'

export default {
  name: 'ContentCreationQRCode',

  components: {
    QRCode,
  },

  data() {
    return {
      reverLogoGrayscale,
      url: `${config.webAppURL}/create`,
    }
  },
}
</script>

<style scoped lang="scss">
.qr-container {
  position: fixed;
  left: -5000px;
  height: 1150px;
  width: 800px;

  h2,
  h4 {
    width: 800px;
  }
}
</style>
